// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2O-e4SLz7B_qE6-b9ELf53"};